<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      教练信息
    </template>
    <div class="scroll_wrap">
      <vue-scroll v-show="!loading">
        <div class="info_item">
          <div class="info_title">
            <img src="@/assets/images/common/player_information.png" alt="">
            基本信息
          </div>
          <div class="base_info">
            <div class="focus-tips" v-if="coach.isAuthComplete === 1" >
              <div class="tips-content" style="background-color: #4CD864">已完成年度注册</div>
            </div>
            <div class="focus-tips" v-else >
              <div class="tips-content" style="background-color: #eb2c2c">未完成年度注册</div>
            </div>

            <div class="col">
              <span>姓名：{{coach.idName}}</span>
              <span>性别：{{coach.gender || '--'}}</span>
            </div>
            <div class="col">
              <span>教练等级：{{coach.classLevel | coachClassLevel}}</span>
              <span>执照有效期：{{coach.coachLicenseEnd || '--'}}</span>
            </div>
            <div class="col" v-if="coach.coachRankPhysicalType">
              <span>体能教练等级：{{coach.coachRankPhysicalType | coachClassLevel}}</span>
              <span>体能执照有效期：{{coach.coachPhysicalLicenseEnd || '--'}}</span>
            </div>
            <div class="col" v-if="coach.coachRankSpecialType">
              <span>守门员教练等级：{{coach.coachRankSpecialType | coachClassLevel}}</span>
              <span>守门员执照有效期：{{coach.coachGoalieLicenseEnd || '--'}}</span>
            </div>
            <div class="col">
              <span>手机号：{{coach.phone}}</span>
              <span>年龄：{{coach.idNumber | filterIdNumber(2)}}</span>
              <!-- <span>籍贯：{{'--'}}</span> -->
            </div>
            <div class="col">
              <span>身份证件号：{{coach.idNumber}}</span>
              <span>生日：{{coach.idNumber | filterIdNumber}}</span>
            </div>
            <div class="col">
              <span>带队年限：{{coach.coachLeadYears ? coach.coachLeadYears+'年' : '--'}}</span>
              <span>最高运动经历：{{coach.coachBestExperience || '--'}}</span>
            </div>
            <div class="col">
              <span>工作类型：{{coach.coachNatureCoach || '--'}}</span>
              <span>教练员劳动/劳务关系佐证材料（协议或社保记录等）：<a
                v-if="coach.fileUrl"
                :href="$yioksConfig.transferBaseOnly(coach.fileUrl)"
                target="_blank"
                :title="coach.fileName"
                style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
              >{{ coach.fileName }}</a>
                <a v-else>--</a>
              </span>
            </div>
            <div class="col">
              <span>输送球员情况：{{coach.coachTransfer || '--'}}</span>
            </div>
            <div class="col">
              <span>带队最好成绩：{{coach.coachBestResult || '--'}}</span>
            </div>
<!--            <div class="col" v-if="coach.fileUrlSecurity">-->
<!--              <span>教练员社保证明：<a-->
<!--                v-if="coach.fileUrlSecurity"-->
<!--                :href="$yioksConfig.transferBaseOnly(coach.fileUrlSecurity)"-->
<!--                target="_blank"-->
<!--                :title="coach.fileNameSecurity"-->
<!--                style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"-->
<!--              >{{ coach.fileNameSecurity }}</a>-->
<!--                <a v-else>&#45;&#45;</a>-->
<!--              </span>-->
<!--            </div>-->
            <div class="col">
              <span :class="{ coachLimit: coach.coachLimitDate < new Date().setHours(0,0,0,0) }">帐号有效期至：{{coach.coachLimitDate | time}} <template v-if="coach.coachLimitDate < new Date().setHours(0,0,0,0)"> （已过期，待缴费）</template></span>
            </div>
          </div>
        </div>
        <div class="info_item">
          <div class="info_title between">
            <div class="flex_box">
              <img src="@/assets/images/common/player_squad.png" alt="">
              所属球队
            </div>
            <!-- <div class="yioks_btn" @click="manageSquad = true">管理球队</div> -->
          </div>
          <div class="score_wrap">
            <div
              v-for="(item, index) in squad"
              :key="index"
              class="score_item"
              @click="goSquad(item)">
              <div class="header">{{item.shortName}}</div>
              <div class="content">
                <img :src="item.banner" alt="" @error="item.banner = squadImg">
                <div class="score_info">
                  <p> <span>区体育行政部门：{{item.organShortName}}</span></p>
                  <p><span>单位：{{item.youthShortName}}</span></p>
                  <p><span>球队职位：{{item.duty || '--'}}</span></p>
                  <p><span>教练数量：{{item.coachTeamNum}}人</span><span>球员数量：{{item.playerTeamNum}}人</span></p>
                </div>
              </div>
            </div>
          </div>
          <yioks-empty v-if="squad.length === 0" :h="'200px'"></yioks-empty>
        </div>
        <div class="info_item">
          <div class="info_title between">
            <div class="flex_box tutorial">
              <img src="@/assets/images/common/session_icon.png" alt="">
              <!-- 创建的教案数量 -->
              {{$t('createdTeachingPlans')}} (
                <span> {{$t('total')}}/{{coach.internalLibraryNum + coach.privateLibraryNum}}</span>
                <span>{{$t('internal')}}/{{coach.internalLibraryNum}}</span>
                <span>{{$t('private')}}/{{coach.privateLibraryNum}}</span>)
            </div>
            <div v-show="total> 2" class="more" @click="goTutorial">更多</div>
          </div>
          <div class="tutorial_wrap" style="margin-bottom: 10px">
            <div
              v-for="(item, index) in tutorial"
              :key="index"
              class="item_box"
              @click="goDetail(item.uuid)">
              <div class="flex_box">
                <img :src="item.coverImgUrl" alt="">
                <p :title="item.title">{{item.title}}</p>
              </div>
              <div class="info">
                <div>
                  <p>作者：{{item.authorName}}</p>
                  <p>分类：{{item.categoryZh}}</p>
                </div>
                <div>
                  <p>球队：{{item.skillLevelZh}}</p>
                  <p>更新：{{item.updatedAt | time(true)}}</p>
                </div>
              </div>
            </div>
          </div>
          <yioks-empty v-if="!total" h='200px'></yioks-empty>
        </div>

        <div class="info_item">
          <div class="info_title between">
            <div class="flex_box tutorial">
              <img src="@/assets/images/common/session_icon.png" alt="">
              训练计划
            </div>
            <div class="more" @click="goCoachPlanList" v-if="plainList && plainList.length > 0">更多</div>
          </div>
          <div v-if="plainList && plainList.length > 0" class="table">
            <div class="thead">
              <div class="tr">
                <div class="th squadName"><strong>所属球队</strong></div>
                <div class="th trainingTime"><strong>训练开始时间</strong></div>
                <div class="th name"><strong>训练主题</strong></div>
                <div class="th trainingAmount"><strong>训练量</strong></div>
                <div class="th trainingAmount"><strong>强度</strong></div>
                <div class="th trainingAmount"><strong>时长</strong></div>
                <div class="th trainingAmount"><strong>状态</strong></div>
                <div class="th opt"><strong>操作</strong></div>
              </div>
            </div>
            <div class="scrollArea">
              <vue-scroll>
                <div class="tbodyWrap">
                  <div class="tbody">
                    <div v-for="(item, index) in plainList" :key="index" class="tr">
                      <div class="td squadName" :title="item.squadName">
                        <p style="white-space: normal">{{ item.organShortName }}-{{ item.youthShortName }}-{{ item.squadName }}</p>
                      </div>
                      <div class="td trainingTime" :title="item.trainingTime | time(true)">
                        <p>{{ item.trainingTime | time(true) }}</p>
                      </div>
                      <template v-if="item.trainingStatus !== 'INITIATED' && item.trainingName !== '休息'">
                        <div class="td name" :title="item.trainingName">
                          <p><span class="itemName" @click="goDetailPlan(item.uuid)">{{item.trainingName || "--"}}</span></p>
                        </div>
                      </template>
                      <template v-else>
                        <div class="td name" :title="item.trainingName">
                          <p>{{ item.trainingName || "--" }}</p>
                        </div>
                      </template>
                      <div class="td trainingAmount" :title="item.trainingAmount">
                        <p>{{ item.trainingAmount || "--" }}</p>
                      </div>
                      <div class="td trainingAmount">
                        <p>{{ item.trainingIntensity || "--" }}</p>
                      </div>
                      <div class="td trainingAmount">
                        <template v-if="item.trainingTotalTime" :title="`${item.trainingTotalTime}分钟`">
                          <p>{{ item.trainingTotalTime || "0" }}分钟</p>
                        </template>
                        <template v-else>
                          <p>--</p>
                        </template>
                      </div>
                      <div class="td trainingAmount">
                        <template v-if="item.trainingName === '休息'">
                          <p>--</p>
                        </template>
                        <template v-else>
                          <p>{{ item.trainingStatus | trainingStatus }}</p>
                        </template>
                      </div>
                      <div class="td opt">
                        <template v-if="item.trainingName === '休息'">
                          <p>--</p>
                        </template>
                        <template v-else>
                          <p><span class="item" @click="goDetailPlan(item.uuid)">查看</span></p>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
          <yioks-empty v-if="!plainList || plainList.length === 0" h='200px'></yioks-empty>
        </div>
      </vue-scroll>
      <yioks-loading v-if="loading"></yioks-loading>
    </div>
  </SubContent>
</template>

<script>

import coach from '@/api/coach'
import squad from "@/api/squad";
import tutorial from '@/api/tutorial'
import training from "@/api/training";
import { filterIdNumber, coachNatureFilters,coachClassLevel } from '@/utils/yioks_filter'
import squadImg from '@/assets/images/common/squad.png'
import storage from '@/utils/storage'
export default {
  components: {
    'SubContent': () => import('@/components/layout/newSubContent')
  },
  filters: {
    filterIdNumber,
    coachNatureFilters,
    coachClassLevel,
    trainingStatus (val) {
      switch (val) {
        case 'INITIATED': return '编写中'
        case 'INCOMPLETE': return '待实施'
        case 'COMPLETE': return '已完成'
        default: return '--'
      }
    }
  },
  data () {
    return {
      coachUuid: this.$route.query.uuid,
      loading: true,
      empty: true,
      squadImg,
      coach: '',
      userRole: storage.get('userInfo').userRole,
      squad: [],
      tutorial: [],
      total: 0,
      whiteUuidList: [],
      plainList: [],

    }
  },
  created () {
    this.getInfo()
    this.getTutorial()
    this.getWhiteUuidList();
    this.getTrainPlan();
  },
  methods: {
    getTrainPlan() {
      this.empty = false;
      let request;
      if (this.userRole === "system" || this.userRole === "admin"|| this.userRole === "expert") {
        request = training.getTrainPlanListSystem;
      } else if (this.userRole === "organ" ) {
        request = training.getTrainPlanListOrgan;
      } else if (this.userRole === "youth" || this.userRole === "club"  || this.userRole === "trainCamp") {
        request = training.getTrainPlanListYouth;
      }
      let data = {
        // status,
        page: 0,
        size: 5,
        authorUserUuid: this.coachUuid,
      };
      request(data)
      .then((res) => {
        if (res.totalElements) {
          this.plainList = res.content;
        } else {
          this.empty = true;
        }
      })
      .catch((err) => {
        this.loading = false;
        console.error(err);
      });
    },
    getInfo () {
      coach.getCoachInfo(this.coachUuid).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
          this.$router.push('/')
        } else {
          this.loading = false
          this.coach = res.coachInformation
          if (Object.keys(res.squadInformation).length > 0) {
            this.squad = res.squadInformation
          }
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    getTutorial () {
      let request
      if (this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert') {
        request = tutorial.getPersonTutorialBySystem
      } else if (this.userRole === 'organ') {
        request = tutorial.getPersonTutorialByOrg
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club' || this.userRole === 'leader' || this.userRole === 'coach') {
        request = tutorial.getPersonTutorialByYouth
      }
      request({ authorUserUuid: this.coachUuid, size: 2 }).then(res => {
        this.tutorial = res.content
        this.total = res.totalElements
      })
    },
      // 获取可查看所属球队名单
    getWhiteUuidList() {
      let request = null;
      const whiteUuidList = [];
      try {
        if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
          // request = squad.getOrgListBySystem;
          // 系统管理员不做处理
          return;
        } else if (this.userRole === "organ") {
          request = squad.getOrgListByOrgan;
          request().then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            if (res.length === 1) {
              res.forEach((orgItem) => {
                whiteUuidList.push(orgItem.organUuid);
              });
              this.whiteUuidList = whiteUuidList;
            } else {
              console.error("error:当前登录协会存在多个协会数据");
              this.whiteUuidList = [];
            }
          });
        } else if (
          this.userRole === "youth" ||
          this.userRole === "trainCamp" ||
          this.userRole === "club"
        ) {
          request = squad.getOrgListByYouth;
          request().then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            if (res.length === 1) {
              if (res[0].youthList.length === 1) {
                res[0].youthList.forEach((youthItem) => {
                  whiteUuidList.push(youthItem.uuid);
                });
                this.whiteUuidList = whiteUuidList;
              } else {
                console.error("error:当前登录青训中心存在多个青训中心角色数据");
                this.whiteUuidList = [];
              }
            } else {
              console.error("error:当前登录协会存在多个协会数据");
              this.whiteUuidList = [];
            }
          });
        } else if(this.userRole === 'coach') {
          request = squad.getSquadListCoachAll
          request().then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            if(res.length) {
              res.forEach(squadItem => {
                whiteUuidList.push(squadItem.squadUuid)
              })
              this.whiteUuidList = whiteUuidList;
            } else{
              console.error("error:当前登录教练不存在球队信息");
            }
          });
        }
      } catch (err) {
        console.error("err", err);
      }
    },
    goSquad (row) {
      const { squadUuid } = row;
      if(this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert') {
      this.$router.push({
        path: '/squad/detail',
        query: {
          uuid: squadUuid
        }
      })
      } else if(this.userRole === 'organ') {
        const { organUuid } = row;
        if(this.whiteUuidList.includes(organUuid)) {
          this.$router.push({
            path: '/squad/detail',
            query: {
              uuid: squadUuid
            }
          })
        } else {
          this.$message.error('很抱歉，您当前没有权限访问该球队信息!')
        }
      } else if(this.userRole === 'youth' || this.userRole === 'club' || this.userRole === 'trainCamp') {
        const { youthUuid } = row;
        if(this.whiteUuidList.includes(youthUuid)) {
          this.$router.push({
            path: '/squad/detail',
            query: {
              uuid: squadUuid
            }
          })
        } else {
          this.$message.error('很抱歉，您当前没有权限访问该球队信息!')
        }
      } else {
        console.error('login user role has error')
      }
    },
    goDetail (uuid) {
      this.$router.push({
        path: '/tutorial/detail',
        query: { uuid }
      })
    },
    goTutorial () {
      this.$router.push({
        path: 'tutorial',
        query: {
          uuid: this.coach.uuid,
          name: this.coach.idName
        }
      })
    },
    goDetailPlan(uuid) {
      this.$router.push({
        path: "/training/detail",
        query: { uuid },
      });
    },
    goCoachPlanList () {
      this.$router.push({
        path: '/training/coach_plan_list',
        query: {
          coachUuid: this.coach.uuid,
          youthShortName: this.coach.idName
        }
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .scroll_wrap
    height 100%
    padding 20px 0 10px 20px
    box-sizing border-box
    overflow hidden
    .info_item
      margin 0 30px 30px 10px
      .info_title
        font-size 20px
        padding 10px 0 20px
        display flex
        align-items center
        img
          margin-right 10px
          width 26px
        &.between
          justify-content space-between
          .flex_box
            display flex
            align-items center
          .tutorial
            span
              padding-right 10px
              padding-left 5px
              &:last-child
                padding-right 5px
        .yioks_btn
          padding 6px 20px
        .more
          padding-right 10px
          cursor pointer
      .base_info
        border 1px solid #FFF
        .focus-tips
          position absolute
          top: 60px;
          right: 31px;
          width: 148px;
          height: 110px;
          overflow hidden
          .tips-content
            width: 156px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            transform rotate(45deg)
            position absolute
            top 35px
            right -33px
        .col
          border-bottom 1px solid
          padding 16px 30px
          display flex
          justify-content space-around
          span
            display inline-block
            width 100%
          &:last-child
            border none
          .coachLimit
            color #f88594 !important
      .score_wrap
        display flex
        flex-wrap wrap
        .score_item
          padding-bottom 20px
          width 395px
          cursor pointer
          &:nth-child(odd)
            margin-right 40px
          .header
            height 30px
            background url('~@/assets/images/common/squad_bg.png') no-repeat
            background-size 261px 30px
            line-height 30px
            padding-left 15px
            font-size 18px
          .content
            border 1px solid #FFF
            padding 20px 15px
            display flex
            img
              width 54px
              height 80px
              margin-right 10px
            .score_info
              p
                margin-bottom 10px
                span
                  margin-right 20px
                  &:last-child
                    margin 0
      .tutorial_wrap
        display flex
        justify-content space-between
        .item_box
          background rgba(0, 0, 0 ,.35)
          border 2px solid transparent
          padding 20px
          width 410px
          cursor pointer
          &:hover
            background rgba(0,0,0,.35) url('~@/assets/images/common/hover_yioks.png') no-repeat right center
            box-shadow inset 0 0 12px $green_color
            border 2px solid $green_color
          .flex_box
            display flex
            border-bottom 1px solid #FFF
            padding-bottom 15px
            img
              margin-right 20px
              height 100px
              width 170px
            p
              width 145px
              text-overflow ellipsis
              overflow hidden
              white-space nowrap
          .info
            display flex
            div
              margin-right 20px
              &:last-child
                margin 0
            p
              margin-top 10px
      .table
        display flex
        flex-direction column
        flex 1
        width 100%
        // margin: 30px 0 0;
        .thead, .tbody
          border 1px solid $color_white
        .thead
          .tr
            height 45px
            display flex
        .scrollArea
          max-height 250px
          padding-bottom 15px
        /* flex 1 */
        /* overflow hidden */
        .tbodyWrap
          display block
        // padding: 0 40px;
        .tbody
          display block
          width 830px
          border-top none
          border-bottom none
          .tr
            height 49px
            display flex
            border-bottom 1px solid $color_white
          .itemName
            cursor pointer
            user-select none
            color $green_color
        .th, .td
          height 100%
          /* flex: 1 1 auto; */
          display flex
          justify-content center
          align-items center
          font-size $font_size_medium
          border-right 1px solid $color_white
        .th:last-child, .td:last-child
          border-right none
        .td
          p
            white-space nowrap
            overflow hidden
            text-overflow ellipsis
            color $color_white
        .squadName
          width 19%
        .seq
          width 7%
        .name
          width 18%
        .trainingAmount
          width 7%
        .trainingTime
          width 19%
        .opt
          // width 12%
          flex 1
          width 8%
          p
            width 100%
            text-align center
            white-space normal
            .item
              cursor pointer
              user-select none
              color $green_color
            .split
              margin 0 5px
    .manageSquad_wrap
      .el-row
        margin-bottom 20px
        .el-col
          line-height 40px
          text-align center
      .btn_wrap
        display flex
        justify-content center
        padding-top 20px
</style>
